module.exports = __webpack_public_path__ + "static/media/blog-single.d1d68964.jpg";